import { FieldName } from 'v2/core/entities/fields';
import {
  EmptyWhereClause,
  WhereClause,
} from 'v2/core/services/queryBuilder/whereClause';
import { create } from 'zustand';
import { AbsoluteTimeRange } from 'v2/core/entities';
import { Category } from '@modules/common/types';

export type FeedbackMetaData = {
  id: string;
  fieldName: FieldName;
  name: string;
  category?: Category;
};

export type ViewFeedbackStore = {
  feedbackWhereClause: WhereClause;
  setFeedbackWhereClause: (newFeedbackWhereClause: WhereClause) => void;
  feedbackTimeRange?: AbsoluteTimeRange;
  setFeedbackTimeRange: (
    newFeedbackTimeRange: AbsoluteTimeRange | undefined,
  ) => void;
  isFeedbackVisible: boolean;
  toggleIsFeedbackVisible: () => void;
  feedbackMetaData?: FeedbackMetaData;
  setFeedbackMetaData: (newFeedbackMetaData?: FeedbackMetaData) => void;
};

const useViewFeedbackStore = create<ViewFeedbackStore>((set) => ({
  feedbackWhereClause: EmptyWhereClause,
  setFeedbackWhereClause: (newFeedbackWhereClause): void =>
    set({
      feedbackWhereClause: newFeedbackWhereClause,
    }),
  setFeedbackTimeRange: (newFeedbackTimeRange): void =>
    set({
      feedbackTimeRange: newFeedbackTimeRange,
    }),
  isFeedbackVisible: false,
  toggleIsFeedbackVisible: (): void =>
    set((state) => ({ isFeedbackVisible: !state.isFeedbackVisible })),
  feedbackMetaData: undefined,
  setFeedbackMetaData: (newFeedbackMetaData): void =>
    set({ feedbackMetaData: newFeedbackMetaData }),
}));

export default useViewFeedbackStore;
